(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-specifications"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__hhSpecsSync) return;
    window.__hhSpecsSync = true;
    // Swap in the table rendered for the newly selected variant. detail.data.html is the parsed
    // section the theme already fetched; a combined-listing product swap re-renders all of <main>.
    document.addEventListener('variant:update', function (event) {
      var html = event && event.detail && event.detail.data && event.detail.data.html;
      if (!html || typeof html.querySelector !== 'function') return;
      var fresh = html.querySelector('[data-hh-specs]');
      var current = document.querySelector('[data-hh-specs]');
      if (!fresh || !current || current.innerHTML === fresh.innerHTML) return;
      current.innerHTML = fresh.innerHTML;
      current.hidden = fresh.hidden;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
